import React from "react";

import { CallLogPanelContext } from "../context/CallLogPanelContext";

import CallLogError from "./CallLogError";
import CallLogHeader from "./CallLogHeader";
import CallLogList from "./CallLogList";
import CallLogPagination from "./CallLogPagination";

export default function CallLogPanel({ children }) {
  return (
    <CallLogPanelContext.Provider value={{}}>
      <div className="rounded-md border-y border-gray-100 bg-white px-3">
        {React.Children.map(children, (child) => React.cloneElement(child))}
      </div>
    </CallLogPanelContext.Provider>
  );
}

CallLogPanel.Header = CallLogHeader;
CallLogPanel.List = CallLogList;
CallLogPanel.Pagination = CallLogPagination;
CallLogPanel.Error = CallLogError;
